export const FETCH_MESSAGES_START = "FETCH_MESSAGES_START"
export const FETCH_MESSAGES_SUCCESS = "FETCH_MESSAGES_SUCCESS"
export const FETCH_MESSAGES_FAILURE = "FETCH_MESSAGES_FAILURE"

export const SEND_MESSAGE_START = "SEND_MESSAGE_START"
export const SEND_MESSAGE_SUCCESS = "SEND_MESSAGE_SUCCESS"
export const SEND_MESSAGE_FAILURE = "SEND_MESSAGE_FAILURE"

export const ADD_MESSAGE = "ADD_MESSAGE"
